import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule({
  state: {},
  mutations: {},
  actions: {
    async fetchFaq({ commit }) {
      commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        const response = await api.get('api/faq/');
        commit('SET_DATA', {data: response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message ? error.message : 'Error loading FAQ');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    faq: state => state.data,
    faqLoading: state => state.loading,
    faqError: state => state.error,
    faqLoaded: state => state.loaded,
  }
})
